<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="DED"><span class="ePub-I">For my mom—the most cinematic woman I know.</span></p>
<p class="DED"> </p>
<p class="DED"><span class="ePub-I">To my four grandparents. My grandfather Melvyn Douglas told me, “When you find someone you can learn from, hold on to them.”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2f4eae16